import { render, staticRenderFns } from "./worldoffice-hic.vue?vue&type=template&id=5be645f2"
import script from "./worldoffice-hic.vue?vue&type=script&lang=js"
export * from "./worldoffice-hic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports